const BrandingJSON = {
  colors: {
    primay:'#2970FF',
    secondary:'#f8fafc',
    primaryText:'#101828',
    secondaryText:'#FFFFFF',
    bodyBackground:'#FFFFFF',
    warningColor:'#D92D20',
  }
}
  export default BrandingJSON